import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useLandlordAuth } from "@/context/LandlordAuthContext";

export function LandlordProtectedRoute() {
  const { landlord } = useLandlordAuth();
  if (landlord === null) return <div className="min-h-screen bg-[#0d0d0d]" data-testid="landlord-loading" />;
  if (!landlord) return <Navigate to="/landlord/login" replace />;
  return <Outlet />;
}
